import { useNavigate, useParams } from "react-router-dom";
import { Eye, Wind, Sparkles, HandHeart, Heart, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { Page, BrandHeader, CloseBtn } from "@/components/Brand";
import { Btn } from "@/components/Btn";

const PRACTICES = [
  { icon: Eye, title: "5-4-3-2-1 grounding", body: "Name 5 things you see, 4 you feel, 3 you hear, 2 you smell, 1 you taste.", mode: "54321" },
  { icon: Wind, title: "Box breathing", body: "In for 4, hold 4, out for 4, hold 4. Repeat until you feel settled.", mode: "box" },
  { icon: Sparkles, title: "Name the feeling", body: "Put a word to what you feel. Naming it softens its grip on you.", mode: null },
  { icon: HandHeart, title: "One kind act", body: "Offer yourself one small kindness right now — water, rest, a stretch.", mode: null },
];

export default function Awareness() {
  const { id } = useParams();
  const navigate = useNavigate();
  const done = () => {
    toast.success("Check-in saved");
    navigate("/", { replace: true });
  };
  return (
    <Page>
      <BrandHeader right={<CloseBtn onClick={done} testId="awareness-close" />} />
      <div className="mt-8 tf-rise">
        <h1 className="text-4xl font-bold text-t-on">A moment of awareness</h1>
        <p className="mt-2 text-t-muted">You're within your window of tolerance. Take a breath and choose what helps.</p>
      </div>
      <div className="mt-8 flex flex-col gap-3">
        {PRACTICES.map(({ icon: Icon, title, body, mode }, i) => (
          <button key={title} disabled={!mode} data-testid={`practice-${mode ?? `static-${i}`}`}
            onClick={() => navigate(`/grounding?mode=${mode}&id=${id}`)}
            className={`tf-card tf-rise tf-d${i + 1} flex items-center gap-4 p-5 text-left transition-[transform,border-color] duration-200 ${mode ? "hover:border-t-brand hover:-translate-y-0.5" : "cursor-default"}`}>
            <span className="w-12 h-12 rounded-2xl bg-t-brand3 text-t-onbrand3 grid place-items-center shrink-0"><Icon size={23} /></span>
            <span className="flex-1">
              <span className="block font-semibold text-t-on">{title}</span>
              <span className="block text-sm text-t-on2 mt-0.5">{body}</span>
            </span>
            {mode ? <ChevronRight size={18} className="text-t-muted" /> : null}
          </button>
        ))}
      </div>
      <div className="mt-10 flex flex-col gap-3">
        <Btn label="Reflect on a trigger" onClick={() => navigate(`/reflection/${id}`, { replace: true })} testId="awareness-reflect" />
        <Btn variant="secondary" icon={<Heart size={18} fill="currentColor" />} label="Log my mood" onClick={() => navigate(`/reflection/${id}?start=mood`, { replace: true })} testId="awareness-log-mood" />
      </div>
    </Page>
  );
}
